import { CSSProperties, FC, useEffect, useRef } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { GroupAnimation } from '../types';
import { animationMap } from '../utils';
import personFallback from '../../../../../assets/animations/metro/persons/person1.json';
import Animation from './Animation';

type Props = {
  animation: GroupAnimation;
  duration: number;
  onAnimationEnd: (animation: GroupAnimation) => void;
  isPaused: boolean;
};

const Group: FC<Props> = ({ animation, duration, onAnimationEnd, isPaused }) => {
  return (
    <div
      className={classNames(styles.group, { [styles[animation.direction]]: Boolean(animation.direction) })}
      style={
        {
          '--size': animation.size,
          '--duration': duration,
          '--half-screen': window.innerWidth / 2,
          animationPlayState: isPaused ? 'paused' : 'running',
        } as CSSProperties
      }
      onAnimationEnd={() => onAnimationEnd(animation)}
    >
      {animation.personIds.map((personId) => (
        <Animation key={personId} className={styles.person} animationData={animationMap[personId] || personFallback} isPaused={isPaused} />
      ))}
    </div>
  );
};

export default Group;
